import { Info } from "lucide-react";

export type Regime = "competencia" | "caixa";

interface Props {
  value: Regime;
  onChange: (r: Regime) => void;
}

const OPTS: { id: Regime; label: string }[] = [
  { id: "competencia", label: "Competência" },
  { id: "caixa", label: "Caixa" },
];

const TOOLTIP =
  "Competência: inclui MtM, depreciação e IRPJ provisão (data de vencimento). " +
  "Caixa: usa data de pagamento, sem MtM/depreciação, IRPJ pago, e inclui D11 " +
  "(mútuos) como saída de caixa.";

export function RegimeToggle({ value, onChange }: Props) {
  return (
    <div className="inline-flex items-center gap-2" data-testid="regime-toggle">
      <div className="inline-flex rounded-lg border border-white/10 bg-indra-azul-deep p-1">
        {OPTS.map((o) => (
          <button
            key={o.id}
            type="button"
            onClick={() => onChange(o.id)}
            data-testid={`regime-opt-${o.id}`}
            aria-pressed={value === o.id}
            className={
              "px-3 py-1 text-xs font-semibold rounded-md transition-colors " +
              (value === o.id
                ? "bg-indra-turquesa text-indra-azul"
                : "text-white/60 hover:text-white")
            }
          >
            {o.label}
          </button>
        ))}
      </div>
      <span className="cursor-help" title={TOOLTIP} data-testid="regime-tooltip">
        <Info size={14} className="text-white/40" />
      </span>
    </div>
  );
}
